// @flow
import React from "react";
import EditOrderModal from "../EditOrderModal.tsx";
import { connect } from "react-redux";
import { SHOW_EDIT_COMMENT_MODAL } from "./reducers/planningTable.tsx";
import * as t from "../../../lib/backend/manufacturing2.generated.types";
import { UPDATE_LINE_ORDER_COMMENT } from "./reducers/linesOrders.tsx";

import type { UpdateLineOrderComment } from "./reducers/linesOrders.tsx";
import type { ReduxState } from "./reducers/reducers.tsx";
import type { ShowEditCommentModal } from "./reducers/planningTable.tsx";

export const onSaveComment = (
    order_uuid: string,
    comment: string,
    reduxDispatch: (args: UpdateLineOrderComment) => void
) => {
    reduxDispatch({
        type: UPDATE_LINE_ORDER_COMMENT,
        data: { order_uuid, comment },
    });
};

type Props = {
    reduxDispatch: (args: ShowEditCommentModal | UpdateLineOrderComment) => void,
    show_edit_comment_modal_order_uuid: string,
};
type State = {};

class PlanningTableEditModal extends React.Component<Props, State> {
    onCloseEditModal = () => {
        this.props.reduxDispatch({
            type: SHOW_EDIT_COMMENT_MODAL,
            data: null,
        });
    };

    onSave = (order: t.IOrderModelBase | null) => {
        if (!order) {
            return;
        }
        const comment = order.order_comment;
        onSaveComment(this.props.show_edit_comment_modal_order_uuid, comment, this.props.reduxDispatch);
        this.props.reduxDispatch({
            type: SHOW_EDIT_COMMENT_MODAL,
            data: null,
        });
    };

    render() {
        return (
            <EditOrderModal
                key={this.props.show_edit_comment_modal_order_uuid}
                show_modal={!!this.props.show_edit_comment_modal_order_uuid}
                onCloseModal={this.onCloseEditModal}
                onSave={this.onSave}
                close_on_save={false}
                order_uuid={this.props.show_edit_comment_modal_order_uuid}
            />
        );
    }
}

export default connect(
    (state: ReduxState, own_props: Props) => {
        const planning_table = state.gantt_chart_planning_table;
        return {
            show_edit_comment_modal_order_uuid: planning_table.show_edit_comment_modal_order_uuid,
        };
    },
    dispatch => ({ reduxDispatch: dispatch })
)(PlanningTableEditModal);
